import { AuthGuard } from '../../../../common/services/Auth.guard';
import { SettingsComponent } from './settings.component';
import { ExpertComponent } from './expert/expert.component';
import { TimeComponent } from './time/time.component';
import { BlacklistComponent } from './blacklist/blacklist.component';
import { AccountComponent } from './account/account.component';
import { ConversationSettingsRoute } from './conversation/conversation.route';
import { ContactSettingsRoute } from './contact/contact.route';
import { TicketSettingsRoute } from './tickets/ticket.route';
import { SwitchboardSettingsRoute } from './switchboard/switchboard.route';
import { OtherSettingsRoute } from './other/other.route';
import { ExpertSettingsRoute } from './expert/expert.route';

export const SettingsRoute = [
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
    data: { role: ['administrator', 'supervisor'] },
    children: [
      { path: '', redirectTo: 'channel', pathMatch: 'full' },
      {
        path: 'working-time',
        component: TimeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'blacklist',
        component: BlacklistComponent,
        canActivate: [AuthGuard],
      },
      { path: 'tenant', component: AccountComponent, canActivate: [AuthGuard] },
      {
        path: 'tenant/siptrunk/:id',
        component: AccountComponent,
        canActivate: [AuthGuard],
      },
      ...ExpertSettingsRoute,
      ...ContactSettingsRoute,
      ...ConversationSettingsRoute,
      ...TicketSettingsRoute,
      ...SwitchboardSettingsRoute,
      ...OtherSettingsRoute,
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/settings.route.ts